<template>
  <!-- #### Note ############## -->
  <v-textarea
    v-model="notes"
    outlined
    dense
    label="Nota"
    :error-messages="errors"
  />
</template>
<script>
import { ref } from '@vue/composition-api'
import store from '@/store'
import { required } from '@/@core/utils/validation'

export default {
  props: {
    source: {
      type: String,
      required: true,
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const errors = ref([])
    const notes = ref('')

    // Guarda la nota, si no tiene valor, se ignora la acción
    const Save = ({ sourceId, sourceKey }) => {
      if (!notes.value || notes.value === '') {
        return
      }

      if ((!sourceId || sourceId === 0) && !sourceKey) {
        throw new Error('At least one of "sourceId" or "sourceKey" props is required and must not be empty.')
      }

      store.dispatch('notes/apiCall', {
        mode: 'Insert',
        request: {
          source: props.source,
          sourceId,
          sourceKey,
          value: notes.value,
        },
      })
    }

    // Valida solo si es obligatorio usando los métodos de "validation"
    // En caso de haber error, los pone en el arreglo de mensajes de error
    function Validate() {
      if (!props.mandatory) {
        return true
      }
      const validationResult = required(notes.value)
      if (validationResult === true) {
        errors.value = []

        return true
      }
      errors.value = [validationResult]

      return false
    }

    // Reinicia el control al valor de "vacío"
    function Clear() {
      notes.value = ''
      errors.value = []
    }

    return {
      notes,
      errors,
      Save,
      Validate,
      Clear,
    }
  },
}
</script>
